module.exports = __webpack_public_path__ + "static/media/sharpko-large-contact.0feb3e61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Sharpko/sharpko-large-contact.jpg
// module id = 704
// module chunks = 0